export const getOptionValue = (option) => {
  if (typeof option === "string") {
    return option;
  }
  return option?.label || option?.inputValue || "";
};
